<template>
	<div>
		


		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Pengecekan Kondisi Mobil - Atap</h5>
			</template>
			<div class="row mt-3">
				<div class="col-sm-4 col-lg-2 col-12 label-car-type">
					<label>Pilih Jenis Kendaraan :</label>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'sedan'"
							disabled
						>
							Sedan
						</button>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'minibus'"
							disabled
						>
							Minibus
						</button>
				</div>
			</div>
			

			<div class="row mt-2">
				<!-- <div class="col-md-9 col-sm-12 col-12 " style="overflow-x:scroll">
					<div class="workOrderParent" :class="{'workOrderOuterAtapSedan' : carType == 'sedan', 'workOrderOuterAtapMinibus' : carType == 'minibus'}">
						<div v-if="carType == 'sedan'" class="workOrderInnerAtapSedan">
							<div class="atapSedan" v-on:click="selectPart('atap.atapMobil' , carType)" :class="{'atapSedanActive' : data.condition.figure.sedan.atap.atapMobil.desc != ''}">
							</div>
							<div class="sunRoofSedan" v-on:click="selectPart('atap.sunRoof' , carType)" :class="{'sunRoofSedanActive' : data.condition.figure.sedan.atap.sunRoof.desc != ''}">
							</div>

						</div>
						<div v-else class="workOrderInnerAtapMinibus">
							<div class="atapMinibus" v-on:click="selectPart('atap.atapMobil' , carType)" :class="{'atapMinibusActive' : data.condition.figure.minibus.atap.atapMobil.desc != ''}">
							</div>
							<div class="sunRoof1Minibus" v-on:click="selectPart('atap.sunRoof1' , carType)" :class="{'sunRoof1MinibusActive' : data.condition.figure.minibus.atap.sunRoof1.desc != ''}">
							</div>
							<div class="sunRoof2Minibus" v-on:click="selectPart('atap.sunRoof2' , carType)" :class="{'sunRoof2MinibusActive' : data.condition.figure.minibus.atap.sunRoof2.desc != ''}">
							</div>

						</div>							
					</div>

					
				</div> -->
				<div class="col-12 p-10" style="overflow-x:scroll">
					<div class="workOrderParent" :class="{'workOrderOuterAtapSedan' : carType == 'sedan', 'workOrderOuterAtapMinibus' : carType == 'minibus'}" v-if="!exit">
							

						<template v-if="carType == 'sedan'">
							<div class="workOrderInnerAtapSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerAtapSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >
								
							</canvas>
						</template>
						<template v-else>
							<div class="workOrderInnerAtapMinibus h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerAtapMinibus h-100 w-100"  id="canvasMinibus" style="z-index:50;" >
								
							</canvas>
						</template>
							
						
					</div>
					<div v-else>
							<img v-if="imageSrc" :src="env.baseImage + '/' + imageSrc"  class="workOrderParent"/>

							<div v-else class="mt-5 mb-5 text-center">
								<h2>Tidak Melakukan Tanda Terima</h2>
							</div>

					</div>
					<img v-if="canvasResult" :src="canvasResult" />
					
					
				</div>
				<div class="col-12 row mt-1 mb-5" v-if="!exit">
					<div class="col-12 mb-2 pl-4 mt-2">
						<label>Pilih Kondisi Berikut untuk Menandai Mobil</label>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-green' : curShape == 'Boncel' , 'btn-outline-secondary' : curShape != 'Boncel'}" class="btn w-100" @click="curShape = 'Boncel'"><i class="fa fa-circle fa-lg mr-2 color-green"></i> Boncel</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-blue' : curShape == 'Baret' , 'btn-outline-secondary' : curShape != 'Baret'}" class="btn w-100" @click="curShape = 'Baret'"><i class="fa fa-circle fa-lg mr-2 color-blue"></i> Baret</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-yellow' : curShape == 'Penyok' , 'btn-outline-secondary' : curShape != 'Penyok'}" class="btn w-100" @click="curShape = 'Penyok'"><i class="fa fa-circle fa-lg mr-2 color-yellow"></i> Penyok</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-red' : curShape == 'Pecah' , 'btn-outline-secondary' : curShape != 'Pecah'}" class="btn w-100" @click="curShape = 'Pecah'"><i class="fa fa-circle fa-lg mr-2 color-red"></i> Pecah</button>
					</div>
					<div class="col-sm-4 col-12 offset-lg-2 col-lg-2 pl-4 text-right mt-2">
						<button class="btn btn-danger w-100" @click="reset">Reset</button>
					</div>
						
				</div>
				<div class="col-12">
					<h4 class="text-center">Kondisi {{carTypes.charAt(0).toUpperCase() + carTypes.slice(1)}}</h4>
					<hr>
					<div class="row">
						<div class="col-4" v-for="checklistCar in Object.keys(data.condition.figure[carType].atap)" :key="checklistCar">
							<div class="row mt-2">
								<div class="col-6">
									<p>{{translatePart(checklistCar).split(/(?=[A-Z])/).join(' ')}}</p>
									
								</div>
								<div class="col-6 text-center">
									<input type="checkbox" disabled  v-model="data.condition.figure[carType].atap[checklistCar].desc" >
								</div>
							</div>
							<p style="font-weight:bold" v-if="exit && data.condition.figure[carTypes].atap[checklistCar].desc != ''">Deskripsi Rusak : <br>{{data.condition.figure[carTypes].atap[checklistCar].desc}}</p>
							<template v-else-if="exit">
								<div class="mt-5"></div>
							</template>
							<hr style="margin-top:5px;margin-bottom:5px;">
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="mt-3 row">
				<template v-for="checklist in checklistSettings" >
					<div class="col-6 col-md-2 mt-2 p-3 text-center " :key="checklist.name" v-if="checklist.name.includes('ATAP_')" >
						<div 
							class="border border-secondary rounded checklist" 
							:class="{'Selected' : checkSettings[checklist.name]}" 
							
							@click="checked(checklist.name)"
						>
							<h5>{{data.condition.checklist[checklist.name] ? 'Terpilih' : 'Tidak Dipilih'}}</h5>
							<img :src="checklist.img ? checklist.img : '/img/WorkOrder/Logo/' + checklist.name.split('ATAP_')[1] + '.png'" class="img-fluid" style="width:100%;height:auto"  alt="Tidak ada Gambar"/>
							<h5>{{checklist.name.split('ATAP_')[1]}}</h5>
						</div>
					</div>
				</template>
			</div> -->
			

			
			
		</panel>

		<div class="row">
			<div class="col-md-6 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6" v-if="!exit">
				<button type="button" class="btn btn-primary w-100 rounded" @click="nextPage" :disabled="apiLoading">Berikutnya</button>
			</div>
			<div class="col-md-3 col-6" v-else>
				<button type="button" class="btn btn-success w-100 rounded" @click="nextPage" :disabled="apiLoading">
					<span v-if="!apiLoading">Selesai</span>
					<template v-else>
						<span class="spinner-grow spinner-grow-sm"></span>
						Loading..
					</template>
				</button>
			</div>
		</div>

		<modalUploadImage :varHeader="partHeader" :var="part" :part="translatePart(part)" @showModalFalse="showModal = false" v-if="showModal" @uploadImage="uploadImage"/>

	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import env from '@/env'
	

	export default {
		components: {
			Multiselect,
			modalUploadImage

		},
		data () {
			return {
				env,
				showModal: false,
				part: '',
				partHeader : '',
				carTypes : this.carType,
				showFrontModal: false,
				checkSettings : this.data.condition.checklist,
				curShape : 'Boncel',
				listOfPoints : [],
				gridMap : null,
				imageSrc : null,
				canvasResult : null
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType', 'title', 'exit', 'apiLoading' , 'previousCheckingCondition', 'apiLoading'],
		mounted () {
			this.loadGridCanvas()
			if(this.exit)
				this.imageSrc = this.previousCheckingCondition.condition.figureOverall.atap.image.length > 0 
				&& this.previousCheckingCondition.condition.figureOverall.atap.image[0] != 'test image'? 
					this.previousCheckingCondition.condition.figureOverall.atap.image[0]
					: null

			if(this.exit) {
				let keys = Object.keys(this.data.condition.figure[this.carType].atap)
				console.log(this.previousCheckingCondition.condition.figure.atap);

				for(var i = 0 ; i < keys.length ; i++) {
					let nowCondition = this.data.condition.figure[this.carType].atap[keys[i]]
					let prevCondition = this.previousCheckingCondition.condition.figure.atap[keys[i]]
					if(prevCondition.desc != '') {
						nowCondition.desc = prevCondition.desc
						console.log(nowCondition)
					}
				}
			}
		},
		methods: {
			async loadGridCanvas() {
				let col = [8, 57, 95, 62];
				let row = [33, 16, 127, 15];

				let  obj = [{
					name : 'atap.atapMobil',
					startCol : 2,
					endCol  : 5,
					startRow : 2 , 
					endRow : 5
				}, {
					name : 'atap.sunRoof',
					startCol : 3,
					endCol  : 4,
					startRow : 3 , 
					endRow : 4
				}]

				let colMinibus = [13, 32, 58, 59, 99, 138]
				let rowMinibus = [16, 26, 4, 132, 4, 26]

				let objMinibus = [{
					name : 'atap.atapMobil',
					startCol : 2,
					endCol  : 7,
					startRow : 2 , 
					endRow : 7
				},{
					name : 'atap.sunRoof1',
					startCol : 3,
					endCol  : 4,
					startRow : 3 , 
					endRow : 6
				},{
					name : 'atap.sunRoof2',
					
					startCol : 5,
					endCol  : 6,
					startRow : 4 , 
					endRow : 5
				}]

				this.gridMap = await this.mapGridCanvas(col , row , obj)
				this.gripMapMinibus = await this.mapGridCanvas(colMinibus , rowMinibus , objMinibus)
			},
			async mapGridCanvas(col , row , obj) {

				for(var i = 0 ; i < obj.length ; i++) {
					let curObj = obj[i]
					curObj.startColLength= col.slice(0 , curObj.startCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endColLength = col.slice(0, curObj.endCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.startRowLength= row.slice(0 , curObj.startRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endRowLength = row.slice(0, curObj.endRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					// console.log(curObj.startColLength , curObj.endColLength , curObj.startRowLength , curObj.endRowLength , curObj.name)
				}
				return obj
			},

			addShape(e = null ,click) {
				if(!e) {
					this.listOfPoints.length = 0
					// this.selected.length = 0
				}
				else {
					let x = 0
					let y = 0

					x = e.offsetX
					y = e.offsetY
					// console.log(x, y)
					

					let selectedGrid = this.carTypes == 'sedan' ? this.gridMap : this.gripMapMinibus

					let area = selectedGrid.filter(z => 
						z.startColLength <=  x &&
						z.endColLength >= x &&
						z.startRowLength <= y &&
						z.endRowLength >= y
					)

					if(area.length > 0) {
						// this.selected.push(area.name)
						
						if(area.length == 1)
							this.data.condition.figure[this.carTypes].right[area[0].name.split('.')[1]] = {
								desc : this.curShape
							}
						else {
							let res = []

							for(var i = 0 ; i < area.length ; i++) {
								let z = area[i]
								res[i] = (z.endColLength - x) + (z.endRowLength - y)
								// console.log(z.name , res[i])
							}

							var max = Math.min(...res)
							let index = res.indexOf(max)
							// console.log(area[index] , max)

							

							// this.selectPart(area[index].name , this.carTypes)
							this.data.condition.figure[this.carTypes].atap[area[index].name.split('.')[1]] = {
								desc : this.curShape
							}
						}
					}
					this.listOfPoints.push({x , y , shape : this.curShape})
				}

				let canvas = null
				let context = null

				if(this.carTypes == 'sedan') {
					canvas = document.getElementById('canvasSedan');
					context = canvas.getContext('2d');
					canvas.width =  238.35
					canvas.height =  225
				}
				else {
					canvas = document.getElementById('canvasMinibus');
					context = canvas.getContext('2d');
					canvas.width =408.604
					canvas.height = 225
				}

				for(var i = 0 ; i < this.listOfPoints.length ; i++) {
					context.beginPath();
					
					let x = this.listOfPoints[i].x
					let y = this.listOfPoints[i].y

					let fillStyle = '';

					if(this.listOfPoints[i].shape == 'Boncel')
						fillStyle = '#29BC53'
					else if(this.listOfPoints[i].shape == 'Penyok')
						fillStyle = '#FFDD05'
					else if(this.listOfPoints[i].shape == 'Baret')
						fillStyle = '#007ED9'
					else if(this.listOfPoints[i].shape == 'Pecah')
						fillStyle = '#FF0000'

					// console

					context.moveTo( this.listOfPoints[i].x + 7.5, this.listOfPoints[i].y );
					context.arc(this.listOfPoints[i].x, this.listOfPoints[i].y, 7.5 ,2*Math.PI,0 *Math.PI);
					context.fillStyle = fillStyle;
					context.fill();
					context.stroke();
				}
				// var dataURL = canvas.toDataURL();
				// console.log(dataURL)
				
				
			},
			reset() {
				this.addShape(null)

				this.data.condition.figureOverall[this.carTypes].atap = { image : [] }
				let keys = Object.keys(this.data.condition.figure[this.carTypes].atap)
				// console.log(keys)

				for(var i = 0 ; i < keys.length ; i++) {
					this.data.condition.figure[this.carTypes].atap[keys[i]] = { desc : '' }
				}
			},
			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'
					else if (strSplit[i] == 'car')
						strSplit[i] = 'mobil'
					else if (strSplit[i] == 'window')
						strSplit[i] = 'kaca'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carTypes].front[part] = url
				else 
					this.data.condition[partHeader][this.carTypes][part] = url
				// alert("Unggah Gambar Berhasil!")

				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.$emit('nextPage')
			},
			nextPage () {
				if(this.data.condition.figureOverall[this.carTypes].atap.image.length > 1) {
					this.$emit('nextPage')
				}
				if(this.exit) {
					this.showModal = true;
					this.part = 'atap'
					this.partHeader = 'figureOverall'
					return
				}
				var destinationCanvas = document.createElement("CANVAS");
				var destCtx = destinationCanvas.getContext('2d');

				var background = new Image();
				let canvasId = this.carTypes == 'sedan' ? 'canvasSedan' : 'canvasMinibus'
				let param = {}

				if(this.carTypes == 'sedan') {
					destinationCanvas.width = 700
					destinationCanvas.height = 400
					
					background.src = "/img/WorkOrder/Sedan/CAMRY TOP.svg";
					param.width = 680
					param.height = 300
					param.offsetX = 10
					param.offsetY = 60
					param.canvasX = 280
					param.canvasY = 97
				}
				else {
					destinationCanvas.width = 700
					destinationCanvas.height = 400
					
					background.src = "/img/WorkOrder/Minibus/ALPHARD TOP.svg";
					param.width = 680
					param.height = 300
					param.offsetX = 10
					param.offsetY = 60
					param.canvasX = 225
					param.canvasY = 97
				}

				// destinationCanvas.width = 700
				// destinationCanvas.height = 400
				// var background = new Image();
				// background.src = "/img/WorkOrder/Sedan/CAMRY TOP.svg";

				let vm = this
				background.onload = async function(){
					destCtx.drawImage(background, param.offsetX , param.offsetY , param.width , param.height );   
					const canvas = document.getElementById(canvasId);
					// console.log(canvas.toDataURL())
				

					destCtx.drawImage(canvas, param.canvasX ,  param.canvasY);

					let modifiedFile = vm.dataURLtoFile(destinationCanvas.toDataURL() , 'image.jpg')
					// vm.canvasResult = destinationCanvas.toDataURL()
					
					let formData = new FormData()

					formData.append('work_order' , modifiedFile)
					
					
					try {
						let url = env.urlStart + "/api/v1/workorder/image"
						let response = await vm.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
						let data = response.data.data
						
						vm.data.condition.figureOverall[vm.carTypes].atap = {
							image : [data.filename]
						}
						vm.$emit('nextPage')
					}   catch (err) {
						vm.$store.dispatch('triggerAlert' , [false , ['Something Went Wrong. Please Try Again Later.' , err]])
						console.log(err)
					}       
				}
			}


		}
	}
</script>

<style scoped>
	.color-green {
		color : #29BC53;
	}
	.color-blue {
		color : #007ED9;
	}
	.color-yellow {
		color : #FFDD05;
	}
	.color-red {
		color : #FF0000;
	}

	.btn {
		border-radius: 30px;
		border : 0.5px solid;
	}

	.btn-green {
		background-color: #29BC5326;
		color : black;
	}

	.btn-blue {
		background-color: #007ED926;
		color : black;
	}
	.btn-yellow {
		background-color: #FFDD0526;
		color : black;
	}
	.btn-red {
		background-color: #FF000026;
		color : black;
	}

	.label-car-type {
		display: flex;
		align-items: center;
		letter-spacing: 0.015em;
		font-size: 14px;
	}
</style>
